import React from 'react';

import { IQuestion } from 'modules/national-certificate';

import TopSection from '../top-section';

import Tests from './tests';
import TextSection from './text-section';

interface IProps {
  data?: IQuestion;
  subject?: string;
}

const ComplexWithSubsTest: React.FC<IProps> = ({ data, subject }) => (
  <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
    <TopSection checked={1} subject={subject} testImage={data?.image} questionId={data?.question_id} title={data?.question_name} />
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <TextSection description={data?.description} />
      <Tests subQuestions={data?.sub_questions} />
    </div>
  </div>
);

export default ComplexWithSubsTest;
